
import React from 'react'

export default props => (
  <svg {...props} className="ChangeColorDark" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      className="stroke"
      d="M4.03365 16.5066C4.47971 22.685 9.89439 27.7117 16.3747 27.9877C20.9468 28.1796 25.0357 26.1161 27.489 22.865C28.505 21.5333 27.9599 20.6455 26.2623 20.9455C25.4322 21.0894 24.5772 21.1494 23.6851 21.1134C17.6261 20.8735 12.6699 15.9667 12.6451 10.1722C12.6327 8.61263 12.9673 7.13701 13.5744 5.79335C14.2435 4.30573 13.4381 3.59792 11.8893 4.23375C6.98261 6.23724 3.62476 11.024 4.03365 16.5066Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
